import Vuex from 'vuex'

import { authentication }  from './modules/authentication';
import { alert }  from './modules/alert';
import { header } from './modules/header';
import { role } from './modules/role';
import { menu } from './modules/menu';
import { roleMenu } from './modules/roleMenu';
import { user } from './modules/user';
import { workspace } from './modules/workspace';
import { roleWorkspace } from './modules/roleWorkspace';
import { roleReport } from './modules/roleReport';
import { userWorkspace } from './modules/userWorkspace';
import { report } from './modules/report';
import { dataset } from './modules/dataset';
import { pentahoLog } from './modules/pentahoLog';

const debug = process.env.NODE_ENV !== 'production'
export const store = new Vuex.Store({
  modules: {
    authentication,
    alert,
    header,
    role,
    menu,
    roleMenu,
    user,
    workspace,
    roleWorkspace,
    roleReport,
    userWorkspace,
    report,
    dataset,
    pentahoLog
  }, strict: debug
});
